import { TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import * as Topics from "Data/Topics";
import * as Constants from "Data/Constants";
import Settings from "Data/Settings";

export class SliderMarker extends HLF.Input.Receptacle {

    public readonly isFocusable = false; // never keyboard focusable
    protected sprite = this._visuals.addChild(new PIXI.Sprite());
    protected _callback?: ()=>void;
    protected _knob: HLF.Input.Draggable;

    public constructor(pKnob: HLF.Input.Draggable, callback?: ()=>void) {
        super();
        this._knob = pKnob;
        this._callback = callback;
        this.interactive = true; // always clickable
        this.buttonMode = false;
        this.hitArea = new PIXI.Circle(0, 0, 20);
    }

    public set isActive(pValue: boolean) {
        super.isActive = pValue;
        if (pValue) {
            this.interactive = true; // always clickable
        }
    }

    public setLayoutTexture(texture: string | PIXI.Texture, anchorX: number, anchorY: number, spritesheet?: string | string[]) {
        if(typeof texture === 'string') {
            texture = texture.replace(/\.png$/, '');
            this.name = texture;
        }
        this.sprite.texture = (texture instanceof PIXI.Texture ? texture :
            texture ? HLF.PixiUtils.getTexture(texture, spritesheet) : PIXI.Texture.EMPTY) || PIXI.Texture.EMPTY;
        this.sprite.anchor.x = anchorX;
        this.sprite.anchor.y = anchorY;
    }

    public getFocusSize() { // for dwell, not keyboard
        let bounds: PIXI.Rectangle;
        if (this.hitArea instanceof PIXI.Rectangle) {
            bounds = HLF.PixiUtils.getGlobalBounds(this, this.hitArea.clone());
        }
        else {
            bounds = HLF.PixiUtils.getGlobalBounds(this);
        }
        return HLF.RectUtils.size(HLF.RectUtils.scale(bounds, 0.5));
    }

    public onFocusActivated() { // for dwell, not keyboard
        this.addDraggable(this._knob);
    }

    protected addDraggable(pDraggable: HLF.Input.Draggable): void {
        if (pDraggable === this._knob) {
            super.addDraggable(pDraggable);
            this._callback?.();
        }
    }

    protected onDragEnd(pTopic: string, pDraggable: HLF.Input.Draggable) {
        super.onDragEnd(pTopic, pDraggable);
        this._dragged = undefined;
        if (this._isActive) {
            this.interactive = true; // always clickable
        }
    }

    protected onDraggableDeselected(pTopic: string, pDraggable: HLF.Input.Draggable) {
        super.onDraggableDeselected(pTopic, pDraggable);
        this._selected = undefined;
        if (this._isActive) {
            this.interactive = true; // always clickable
        }
    }

    protected onPointerOver(): void {
        super.onPointerOver();
    }

    protected onPointerOut(): void {
        super.onPointerOut();
    }

    protected onPointerUp() {
        if (this._eventData !== undefined && this._dragged === undefined && this._selected === undefined) {
            if (!Settings.useDwellActivation) {
                this.addDraggable(this._knob); // jump to click
            }
        }
        super.onPointerUp();
    }
}